import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useInView } from "react-intersection-observer";
import SectionTitle from "../SectionTitle";
import Tilt from "react-parallax-tilt";
import photoMoi from "../../Assets/sam.png";

function Home2() {
  const [ref, inView] = useInView({
    triggerOnce: true, // L'animation se déclenche une seule fois
    threshold: 0.1, // L'élément doit être visible à 10% pour déclencher l'animation
  });

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;

  let date = new Date();
  let age = date.getFullYear() - 2003;

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
            <div ref={ref}>
                <SectionTitle index="01" title="À propos de moi" />
                <Row className="home-about-description">
                    <Col
                        md={5}
                        style={{
                            paddingTop: isMobile ? "20px" : "0px",
                            paddingBottom: 20,
                            display: "flex", // Active Flexbox
                            justifyContent: "center", // Centre horizontalement
                            alignItems: "center", // Centre verticalement
                        }}
                    >
                        <Tilt>
                            <div
                                style={{
                                    position: "relative", // Position relative pour contenir l'image
                                    display: "inline-block", // Permet de gérer la bordure autour de l'image
                                }}
                            >
                                <div className="photo-frame frame-a"></div>
                                <div className="photo-frame frame-b"></div>
                                <img
                                    src={photoMoi}
                                    alt="home pic"
                                    className="img-fluid"
                                    style={{
                                        maxHeight: "350px",
                                        borderRadius: "50px",
                                        position: "relative", // Position relative pour être au-dessus de la bordure
                                        zIndex: 2, // Place l'image au-dessus de la bordure
                                        transform: inView ? "translateX(0)" : "translateX(-100%)", // Animation
                                        opacity: inView ? 1 : 0, // Apparition progressive
                                        transition: "all 0.8s ease-out", // Durée et effet de la transition
                                        border: "4px solid rgba(255, 255, 255, 0.9)",
                                    }}
                                />
                            </div>
                        </Tilt>
                    </Col>
                    <Col md={7} style={{ paddingBottom: 20 }}>
                        <p
                            className="home-about-body glass-card"
                            style={{
                                transform: inView ? "translateX(0)" : "translateX(-100%)", // Animation
                                opacity: inView ? 1 : 0, // Apparition progressive
                                transition: "all 0.8s ease-out", // Durée et effet de la transition
                            }}
                        >
                            Enchanté Samuel Launay, {age} ans, j'habite à 20 minutes de Caen et je suis développeur Web Full-Stack.
                            <br />
                            <br />
                            Actuellement, salarié chez <b>Teclib</b> en tant que <b>cadre Développeur eb FullStack</b>. Je contribues à l'évolution de GLPI et de ses plugins.
                            J'aime aussi créer des sites ou des applications sur mon temps libre.
                            <br />
                            <i style={{ fontSize: 15}}>PS : Ils sont dans l'onglet <b><a href="#project" className="link-accent">Projets</a></b> si ça vous interresse.</i>
                            <br />
                            <br />
                            Mais le développement n’est qu’une partie des nombreux centres d’intérêt qui me font vivre et je serais ravi de vous en faire profiter !
                        </p>
                    </Col>
                </Row>
            </div>
      </Container>
    </Container>
  );
}

export default Home2;
